// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--- Chat Structure ---*/
.chatContainer{
    display: flex;
    flex-direction: column;
    height: 90% !important;
    width: 100% !important;
    margin-top: 1%;
    border-radius: 5px;
    border: rgb(38, 38, 38) solid 2px;
}

.chatMessageContainer {
    display: flex;
    flex-direction: column;
    border-radius: 0px;
    margin-top:1%;
    margin-bottom: 1%;
    width: 100% !important;
    height: 100% !important;
    overflow-y: auto;
    word-wrap: break-word;
    border-bottom: 2px solid black;
    
}
.homeview{
    height: 100% !important;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.inputSection{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    min-height: -moz-fit-content;
    min-height: fit-content;
    margin: 1%;
    width: 98% !important;

    align-content: center;
    justify-content: center;
    align-items: center;
}
/* -- text input area -- */
.inputArea{
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin:1%;
    resize: none;
    height: 50px !important;
}
.keyInfoArea{
    display: flex;
    flex-direction: column;
    height: 50px;
    margin:1%;
    resize: none;
}

.sendButton{
    display: flex;
    flex-direction: column;
    max-height: -moz-fit-content;
    max-height: fit-content;
    width: -moz-fit-content;
    width: fit-content;

    color: black;
    border: 3px solid rgb(99, 36, 159);
    border-radius: 5px;
    background-color: white;

    text-align: center;
    padding-bottom: 0 !important;

    font-size:x-large !important;
}
.sendButton:hover{
    color: white;
    background-color: rgb(99, 36, 159);
}

.resetButton{
    display: flex;
    flex-direction: column;
    max-height: -moz-fit-content;
    max-height: fit-content;
    width: -moz-fit-content;
    width: fit-content;

    color: black;
    border: 3px solid rgb(159, 36, 36);
    border-radius: 5px;
    background-color: white;

    text-align: center;
    padding-bottom: 0 !important;

    font-size:x-large !important;
}
.resetButton:hover{
    color: white;
    background-color: rgb(159, 36, 36);
}

/*--- Chat Bubbles ---*/
.responseRow{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100% !important;
    justify-content: flex-start;

    margin-top: 3px;
    padding: 1%;

}

.response {
    display: flex;
    flex-direction: column;
    max-width: 45% !important;
    padding: 1%;
    border-radius: 20px;

    background-color: rgb(99, 36, 159); 
    color: white; 
}

.requestRow{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100% !important;
    justify-content: flex-end;

    margin-top: 3px;
    padding: 1%;

}
.request {
    display: flex;
    flex-direction: column;
    max-width: 45% !important;
    padding: 1%;
    border-radius: 20px;

    background-color: rgba(225, 191, 254, 0.689);
    color: black;
    border: 1px solid rgb(99, 36, 159);
}







`, "",{"version":3,"sources":["webpack://./src/css/common.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;;AAElC;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,UAAU;IACV,qBAAqB;;IAErB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;AACA,0BAA0B;AAC1B;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,4BAAuB;IAAvB,uBAAuB;IACvB,uBAAkB;IAAlB,kBAAkB;;IAElB,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;;IAEvB,kBAAkB;IAClB,4BAA4B;;IAE5B,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,4BAAuB;IAAvB,uBAAuB;IACvB,uBAAkB;IAAlB,kBAAkB;;IAElB,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;;IAEvB,kBAAkB;IAClB,4BAA4B;;IAE5B,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,kCAAkC;AACtC;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,2BAA2B;;IAE3B,eAAe;IACf,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;;IAEnB,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,yBAAyB;;IAEzB,eAAe;IACf,WAAW;;AAEf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;;IAEnB,4CAA4C;IAC5C,YAAY;IACZ,kCAAkC;AACtC","sourcesContent":["/*--- Chat Structure ---*/\n.chatContainer{\n    display: flex;\n    flex-direction: column;\n    height: 90% !important;\n    width: 100% !important;\n    margin-top: 1%;\n    border-radius: 5px;\n    border: rgb(38, 38, 38) solid 2px;\n}\n\n.chatMessageContainer {\n    display: flex;\n    flex-direction: column;\n    border-radius: 0px;\n    margin-top:1%;\n    margin-bottom: 1%;\n    width: 100% !important;\n    height: 100% !important;\n    overflow-y: auto;\n    word-wrap: break-word;\n    border-bottom: 2px solid black;\n    \n}\n.homeview{\n    height: 100% !important;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n}\n\n.inputSection{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    min-height: fit-content;\n    margin: 1%;\n    width: 98% !important;\n\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n}\n/* -- text input area -- */\n.inputArea{\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    margin:1%;\n    resize: none;\n    height: 50px !important;\n}\n.keyInfoArea{\n    display: flex;\n    flex-direction: column;\n    height: 50px;\n    margin:1%;\n    resize: none;\n}\n\n.sendButton{\n    display: flex;\n    flex-direction: column;\n    max-height: fit-content;\n    width: fit-content;\n\n    color: black;\n    border: 3px solid rgb(99, 36, 159);\n    border-radius: 5px;\n    background-color: white;\n\n    text-align: center;\n    padding-bottom: 0 !important;\n\n    font-size:x-large !important;\n}\n.sendButton:hover{\n    color: white;\n    background-color: rgb(99, 36, 159);\n}\n\n.resetButton{\n    display: flex;\n    flex-direction: column;\n    max-height: fit-content;\n    width: fit-content;\n\n    color: black;\n    border: 3px solid rgb(159, 36, 36);\n    border-radius: 5px;\n    background-color: white;\n\n    text-align: center;\n    padding-bottom: 0 !important;\n\n    font-size:x-large !important;\n}\n.resetButton:hover{\n    color: white;\n    background-color: rgb(159, 36, 36);\n}\n\n/*--- Chat Bubbles ---*/\n.responseRow{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 100% !important;\n    justify-content: flex-start;\n\n    margin-top: 3px;\n    padding: 1%;\n\n}\n\n.response {\n    display: flex;\n    flex-direction: column;\n    max-width: 45% !important;\n    padding: 1%;\n    border-radius: 20px;\n\n    background-color: rgb(99, 36, 159); \n    color: white; \n}\n\n.requestRow{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 100% !important;\n    justify-content: flex-end;\n\n    margin-top: 3px;\n    padding: 1%;\n\n}\n.request {\n    display: flex;\n    flex-direction: column;\n    max-width: 45% !important;\n    padding: 1%;\n    border-radius: 20px;\n\n    background-color: rgba(225, 191, 254, 0.689);\n    color: black;\n    border: 1px solid rgb(99, 36, 159);\n}\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
